
const readTextFile = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            return resolve(reader.result);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsText(file);
    })
}

const readAsArrayBuffer = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            return resolve(reader.result);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsText(file)
    })
}

const readAsDataUrl = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            return resolve(reader.result);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsDataURL(file)
    })
}

const readAsBase64 = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result.split(',')[1]; // base64 string
            return resolve(base64String);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsDataURL(file)
    })
}

const FileHelper = {
    readTextFile,
    readAsArrayBuffer,
    readAsBase64,
    readAsDataUrl
}

export default FileHelper
